import React, { useState } from "react";
import { RiMenu2Fill } from "react-icons/ri";
import UserIcon from "../../Assets/Icons/user.png";
import { Button, Menu, MenuItem } from "@material-ui/core";
import { IoMdSettings } from "react-icons/io";
import { CiSearch } from "react-icons/ci";
import secureLocalStorage from "react-secure-storage";
import { useLocation, useNavigate } from "react-router-dom";

// xxxxxxxxxxxxx
const Header = ({
  handleRefreshBeforeLogout,
  profile_image,
  handleSidebar,
}) => {
  let user = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"));
  let auditUser = JSON.parse(
    secureLocalStorage.getItem("user__UUID__QualityManager")
  );

  const location = useLocation();

  const navigate = useNavigate();
  const handleLogout = () => {
    handleRefreshBeforeLogout();
    secureLocalStorage.removeItem("user_UUID_MFG");
    secureLocalStorage.removeItem("user__UUID__QualityManager");
    navigate("/login");
  };

  // Menu Icon
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // console.log("USER: ", user);

  // let URI = secureLocalStorage.getItem("BaseURI");
  // console.log("URI: ", URI);

  // const isAuthenticated = JSON.parse(
  //   secureLocalStorage.getItem("user_UUID_MFG")
  // );
  // console.log("ISAUTHENTICATED: ", isAuthenticated?.data?.token);

  // console.log("USER AUDIT: ", auditUser);

  // console.log("LOCATION: ", location.pathname.startsWith("/qualitymanager"));

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Left Side Search Bar & Menu Icon */}
        <div>
          <Button onClick={handleSidebar}>
            <RiMenu2Fill size={30} color="white" />
          </Button>
        </div>
        {/* Left Side Search Bar & Menu Icon */}

        {/* Right Side User Name & settings dropdown icon */}
        <div>
          <div>
            <img src={profile_image || UserIcon} alt="" />
            <div>
              <p>
                {location.pathname.startsWith("/qualitymanager")
                  ? auditUser && auditUser?.data?.username
                  : (user && user?.User?.name) || user?.data?.firstname}
              </p>
              <Button onClick={() => handleLogout()}>Logout</Button>
            </div>
          </div>
          <div>
            <Button
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              <IoMdSettings size={30} color="white" />
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem
                onClick={() => {
                  handleLogout();
                  handleClose();
                }}
              >
                Logout
              </MenuItem>
            </Menu>
          </div>
        </div>
        {/* Right Side User Name & settings dropdown icon */}
      </div>
    </nav>
  );
};

export default Header;
